import { frontendURL } from '../../../../helper/URLHelper';
import {
  LABEL_MANAGE_PERMISSIONS,
  LABEL_CREATE_PERMISSIONS,
  LABEL_EDIT_PERMISSIONS,
  LABEL_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            permissions: [
              'administrator',
              LABEL_MANAGE_PERMISSIONS,
              LABEL_CREATE_PERMISSIONS,
              LABEL_EDIT_PERMISSIONS,
              LABEL_DELETE_PERMISSIONS,
            ],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            permissions: [
              'administrator',
              LABEL_MANAGE_PERMISSIONS,
              LABEL_CREATE_PERMISSIONS,
              LABEL_EDIT_PERMISSIONS,
              LABEL_DELETE_PERMISSIONS,
            ],
          },
          component: Index,
        },
      ],
    },
  ],
};
